<template>
  <div>
    <v-toolbar color="primary" dark>
      <v-toolbar-title>
        <h5 class="white--text font-weight-light">
          <slot name="title"></slot>
        </h5>
      </v-toolbar-title>
      <v-spacer />
      <base-icon-close @close="onCloseDialogHandler" :x_small="true"></base-icon-close>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  components: {
    BaseIconClose: () => import('@/components/BaseIconClose')
  },
  methods: {
    onCloseDialogHandler() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
